import React from "react";
import withIntl from "../../../../utils/withIntl";
import { Checkbox, FormControlLabel, Grid, TextField, Typography } from "@material-ui/core";
import PrintInhouseBillView from "./PrintInhouseBillView";

function InhouseBillLayoutEdit(props) {
  const layoutOptions = props.layoutOptions;
  const setLayoutOptions = props.setLayoutOptions;
  return (
    <>
      <Typography variant={"h6"} style={{ fontWeight: 800 }}>
        Inhouse Bill
      </Typography>
      <Grid container>
        <Grid container spacing={1} item xs={8}>
          <Grid item xs={6}>
            {props.intl.formatMessage({ id: "header" })}
          </Grid>
          <Grid item xs={6}>
            <TextField
              multiline={true}
              value={layoutOptions.order_total_receipt.header}
              onChange={(e) => {
                layoutOptions.order_total_receipt.header = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            />
          </Grid>
          <Grid item xs={6}>
            {props.intl.formatMessage({ id: "footer" })}
          </Grid>
          <Grid item xs={6}>
            <TextField
              multiline={true}
              value={layoutOptions.order_total_receipt.footer}
              onChange={(e) => {
                layoutOptions.order_total_receipt.footer = e.target.value;
                setLayoutOptions({ ...layoutOptions });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.order_total_receipt.drawers_pins_on ?? false}
                  onChange={(e) => {
                    layoutOptions.order_total_receipt.drawers_pins_on = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Cash drawer"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.order_total_receipt.buzzer ?? false}
                  onChange={(e) => {
                    layoutOptions.order_total_receipt.buzzer = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"Play buzzer when printing"}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color={"primary"}
                  checked={layoutOptions.order_total_receipt.article?.newline ?? true}
                  onChange={(e) => {
                    if (!layoutOptions.order_total_receipt.article) {
                      layoutOptions.order_total_receipt.article = {}
                    }
                    layoutOptions.order_total_receipt.article.newline = e.target.checked;
                    setLayoutOptions({ ...layoutOptions });
                  }}
                />
              }
              label={"New line between orderlines"}
            />
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <PrintInhouseBillView layoutOptions={layoutOptions.order_total_receipt} />
        </Grid>
      </Grid>
    </>
  );
}

export default withIntl(InhouseBillLayoutEdit);
